import { ReactElement, useState } from "react";

interface IGanttSlider {
  width: number;
  top: number;
  totalPages: number;
  onPageChanged: (offset: number) => void;
}

const backRectHeight = 10;
const frontRectHeight = 20;
const backRectTop = 15;
const frontRectTop = 10;

const GanttSliderPages = ({ width, top, totalPages, onPageChanged }: IGanttSlider): ReactElement => {
  const [ offset, setOffset ] = useState(0);

  const windowWidth = width / totalPages;

  const onMouseDown = (forward: boolean) => {
    if (forward) {
      if(offset + 1 < totalPages) {
        setOffset(offset + 1);
        onPageChanged(offset + 1);
      }
    } else {
      if (offset > 0) {
        setOffset(offset - 1);
        onPageChanged(offset - 1);
      }
    }
  };

  return(
    <g transform={`translate(${0}, ${top})`}>


      <rect
        fill="#AFAFAF"
        x={0}
        y={backRectTop}
        width={width}
        height={backRectHeight} />

      <rect
        fill="transparent"
        stroke="#5F88DC"
        strokeWidth={4}
        x={offset * windowWidth}
        y={frontRectTop}
        rx={2}
        ry={2}
        width={windowWidth}
        height={frontRectHeight}
      />


      {offset > 0 &&
        <g transform={"translate(0, 0)"}
          onMouseUp={() => onMouseDown(false)}
          onTouchEnd={() => onMouseDown(false)}>
          <rect
            stroke="#AFAFAF"
            fill="#FFF"
            x={0}
            y={0}
            width={40}
            height={40}
            rx={20}
            ry={20}
            cursor="pointer"
          />
          <g transform="translate(-2, 0)">
            <path
              d="M25.5,5.5 C25.5,5.5 30.5,10.5 30.5,10.5 C30.5,10.5 20.5,20.5 20.5,20.5 C20.5,20.5 30.5,30.5 30.5,30.5 C30.5,30.5 25.5,35.5 25.5,35.5 C25.5,35.5 10.5,20.5 10.5,20.5 C10.5,20.5 25.5,5.5 25.5,5.5"
              fill="#AFAFAF"/>
          </g>
        </g>
      }

      {offset + 1 < totalPages &&
        <g transform={`translate(${width - 40}, 0)`}
          onMouseUp={() => onMouseDown(true)}
          onTouchEnd={() => onMouseDown(true)}>
          <rect
            stroke="#AFAFAF"
            fill="#FFF"
            x={0}
            y={0}
            width={40}
            height={40}
            rx={20}
            ry={20}
            cursor="pointer"
          />
          <g transform={"translate(1, 0)"}>
            <path
              d="M15.5,5.5 C15.5,5.5 10.5,10.5 10.5,10.5 C10.5,10.5 20.5,20.5 20.5,20.5 C20.5,20.5 10.5,30.5 10.5,30.5 C10.5,30.5 15.5,35.5 15.5,35.5 C15.5,35.5 30.5,20.5 30.5,20.5 C30.5,20.5 15.5,5.5 15.5,5.5"
              fill="#AFAFAF"/>
          </g>
        </g>
      }
    </g>
  );
};

export default GanttSliderPages;
